import { useProyectos, type ProyectoLista } from "../lib/proyectos";
import { Campo, Seleccion } from "./ui";

export interface ProyectoResumen {
  id: string;
  nombre: string;
  clave: string | null;
}

interface Props {
  /** Los proyectos se filtran por cliente: uno pertenece a un solo cliente. */
  clienteId: string | undefined;
  valor: ProyectoResumen | null;
  alSeleccionar: (proyecto: ProyectoResumen | null) => void;
}

/**
 * A diferencia de clientes o servicios, aquí un `<select>` normal alcanza:
 * los proyectos de un cliente son pocos, no hace falta un buscador modal.
 */
export function SelectorProyecto({ clienteId, valor, alSeleccionar }: Props) {
  // Sin cliente, la consulta se queda apagada del todo: pasar `undefined`
  // como filtro cae en el default `{}` de useProyectos (sin filtro) y
  // traería los proyectos de TODOS los clientes, no ninguno.
  const { data } = useProyectos(
    { clienteId },
    { habilitado: !!clienteId },
  );
  const proyectos = clienteId ? (data ?? []) : [];

  const alCambiar = (id: string) => {
    if (!id) {
      alSeleccionar(null);
      return;
    }
    const p = proyectos.find((x) => x.id === id);
    if (p) alSeleccionar({ id: p.id, nombre: p.nombre, clave: p.clave });
  };

  return (
    <Campo
      etiqueta="Proyecto"
      ayuda={clienteId ? "Opcional" : "Selecciona primero un cliente"}
    >
      <Seleccion
        value={valor?.id ?? ""}
        onChange={(e) => alCambiar(e.target.value)}
        disabled={!clienteId}
      >
        <option value="">Sin proyecto</option>
        {proyectos.map((p: ProyectoLista) => (
          <option key={p.id} value={p.id}>
            {p.clave ? `${p.clave} · ${p.nombre}` : p.nombre}
          </option>
        ))}
      </Seleccion>
    </Campo>
  );
}
